import PrintBuilding from './PrintBuilding';

export default PrintBuilding;



// WEBPACK FOOTER //
// ./src/containers/PrintBuilding/index.js